import { MapResponse } from '@empathy/search-adapter';
import { Facet } from '@empathy/search-types';

export const TuandcoFacetMapper: MapResponse<Facet> = (rawFacet: any, facet: Facet) =>  {
  return Object.assign(facet, {
    title: rawFacet.facet.replace('_facet', '').replace(/_/g, ' '),
  });
};



